// Translation boundary for /api/me's permissions block (kebab wire -> camel FE).
// Keep pure: no axios, no side effects. See src/CLAUDE.md.
//
// Default-deny by construction: every flag is coerced from a possibly-absent key, so a
// response predating a flag (or an error-shaped 2xx) reads as "not allowed" rather than
// undefined. The shell gates staff-only chrome on these booleans.
export const mapMePermissions = (perms) => {
  const p = perms ?? {};

  return {
    canCreateCompany: !!p['can-create-company'],
    canCreateProject: !!p['can-create-project'],
    canViewAdminReports: !!p['can-view-admin-reports'],
    canExportAccounts: !!p['can-export-accounts'],
  };
};
